import React from "react";
import { motion } from "framer-motion";
import { Server, Shield, Phone, Code, Wrench, Network } from "lucide-react";

export default function Services() {
  const services = [
    {
      icon: <Server className="w-10 h-10 text-primary mb-4" />,
      title: "Vente de matériel informatique et réseaux",
      description:
        "Fourniture et intégration d’équipements informatiques et réseaux adaptés aux besoins de votre entreprise.",
    },
    {
      icon: <Network className="w-10 h-10 text-primary mb-4" />,
      title: "Déploiement infrastructure réseau IT ",
      description:
        "Installation, configuration et câblage complet de réseaux informatiques et électriques professionnels.",
    },
    {
      icon: <Shield className="w-10 h-10 text-primary mb-4" />,
      title: "Sécurité informatique",
      description:
        "Mise en place de solutions de sécurité : pare-feux, antivirus, VPN, audit et protection de données.",
    },
    {
      icon: <Phone className="w-10 h-10 text-primary mb-4" />,
      title: "Solutions téléphoniques et VoIP",
      description:
        "Déploiement de systèmes de téléphonie IP, communication unifiée et interconnexion multi-sites.",
    },
    {
      icon: <Code className="w-10 h-10 text-primary mb-4" />,
      title: "Création d’applications et de sites web",
      description:
        "Développement sur mesure de solutions web modernes, performantes et sécurisées.",
    },
    {
      icon: <Wrench className="w-10 h-10 text-primary mb-4" />,
      title: "Maintenance et support technique",
      description:
        "Assistance, supervision et maintenance proactive de vos systèmes informatiques.",
    },
  ];

  // Animation parent (cascade lente)
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.35, // délai plus long entre les cartes
      },
    },
  };

  // Animation des cartes individuelles
  const card = {
    hidden: { opacity: 0, y: 50 },
    show: { opacity: 1, y: 0, transition: { duration: 1, ease: "easeOut" } }, // plus fluide
  };

  return (
    <motion.section
      id="services"
      className="py-20 bg-gray-100 px-6 md:px-16"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={container}
    >
      {/* Titre et description */}
      <motion.div
        className="text-center mb-12"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <h2 className="text-4xl font-bold text-primary mb-4">Nos Services</h2>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Virtuo Systems Maroc offre une gamme complète de solutions informatiques
          pour accompagner la transformation digitale de votre entreprise.
        </p>
      </motion.div>

      {/* Cartes de services */}
      <motion.div
        className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto"
        variants={container}
      >
        {services.map((service, index) => (
          <motion.div
            key={index}
            variants={card}
            whileHover={{
              scale: 1.05,
              boxShadow: "0px 15px 35px rgba(0,0,0,0.1)",
            }}
            transition={{ type: "spring", stiffness: 200 }}
            className="bg-white p-8 rounded-2xl shadow-md text-center cursor-default"
          >
            {service.icon}
            <h3 className="text-xl font-semibold text-[#0F172A] mb-3">
              {service.title}
            </h3>
            <p className="text-gray-600 text-sm">{service.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </motion.section>
  );
}
